<template>
  <div v-if="bodyShow" class="ms-information">
    <div class="ms-bg"></div>
    <div class="ms-infor">
      <h3>{{dataObj.description}}</h3>
      <div v-for="(item,index) in component" :key="index">
        <!-- text -->
        <div v-if="item.type=='text'" class="infor-group">
          <h4>{{item.title}}</h4>
          <input :disabled="!item.fillable" type="text" :placeholder="`请填写你的${item.title}${item.required?'（必填）':''}`" @input="validationHandle()" v-model="userInfo[item.name]"  />
        </div>
        <!-- tel -->
        <div v-if="item.type=='tel'" class="infor-group">
          <h4>{{item.title}}</h4>
          <input :disabled="!item.fillable" type="text" :placeholder="`请填写你的${item.title}${item.required?'（必填）':''}`" @blur="validationBlur(item.name)" @input="validationHandle()" v-model="userInfo[item.name]"  />
        </div>
        <!-- 城市 -->
        <div v-if="item.type=='city_picker'" class="infor-group">
          <h4>{{item.title}}</h4>
          <div class="select">
            <span
              :class="['input',userInfo[item.name]?'color3':'']"
              @click="cityHandle(item.name)"
            >{{userInfo[item.name]?userInfo[item.name]:`请填写你的${item.title}${item.required?'（必填）':''}`}}</span>
            <span class="bottom">
              <img @click="cityHandle(item.name)" src="@a/receive_bottom.png" />
            </span>
          </div>
        </div>

        <!-- picker -->
        <div v-if="item.type=='picker'" class="infor-group">
          <h4>{{item.title}}</h4>
          <div class="select">
            <span
              :class="['input',userInfo[item.name]?'color3':'']"
              @click="selectHandle(item.name,item.option)"
            >{{userInfo[item.name]?userInfo[item.name]:`请填写你的${item.title}${item.required?'（必填）':''}`}}</span>
            <span class="bottom">
              <img @click="selectHandle(item.name,item.option)" src="@a/receive_bottom.png" />
            </span>
          </div>
        </div>

        <!-- 单选 -->
        <!-- choice -->
        <div v-if="item.type=='choice'" class="infor-group">
          <h4>{{item.title}}</h4>
          <div class="radio-group">
            <label @click="radioHandle(item.name,item2)" v-for="(item2,index2) in item.option">
              <div :class="['radio',userInfo[item.name]==item2?'on':'']"></div>
              {{item2}}
            </label>
          </div>
        </div>
      </div>
      <!-- 提交 -->
      <div class="submit-group">
        <a :class="['submitBtn',bool?'on':'']" @click="saveFrom()">立即报名</a>
      </div>
    </div>
    <!-- 省市弹出层 @close="pickerShowClick(false)" -->
    <van-popup v-model="citysShow" position="bottom">
      <van-area
        ref="areas"
        :area-list="areaList"
        :columns-num="2"
        :value="userInfo.city"
        @cancel="citysShow=false"
        @confirm="cityCfm"
      />
    </van-popup>
    <!-- 下拉窗口 -->
    <van-popup class="popup" v-model="pickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="options[selectType]"
        :default-index="0"
        @cancel="pickerShow=false"
        @confirm="puckerCfm"
      />
    </van-popup>
  </div>
</template>

<script>
import areaList from "@/utils/area";
import { deepCopy } from "@u/tools";
import { ceping_present,ceping_submit } from "@/api/measurement_system";
import { phoneValidation } from "@u/validation";
export default {
  data() {
    return {
      bodyShow:false,
      userInfo: {},
      areaList, //省市数组
      citysShow: false,
      options: {}, //选项
      pickerShow: false, //下拉窗选项
      selectType: "", //所点击的下拉窗
      bool: false, //必填验证
      // 组件
      component:[],
      dataObj:{}
    };
  },
  methods: {
    // 城市选择的
    cityHandle(val){
      this.$forceUpdate();
      this.selectType = val;
      this.citysShow = true;
    },
    // 选中的单选
    radioHandle(t,val){
      
      this.$forceUpdate();
      this.userInfo[t] = val;
      this.validationHandle();
    },
    /*
     *@param:
     *@return:
     *@Description: 提交表单
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:19:44
     */
    saveFrom() {
      if (!this.bool) {
        this.$toast("必填项不能为空！");
        return;
      }
      //调用加载中
      this.$emit('loadingHandle',true,"加载中...");
      let u = deepCopy(this.userInfo);
      u['form_id'] = this.dataObj.form_id;
      ceping_submit(u).then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        //关闭加载中
        this.$emit('loadingHandle',false);
        this.$toast.success({
          mask: true,
          duration:1500,
          message: '提交成功！',
          onClose:()=>{
            this.$router.push({
              path:'/receive_success',
              query:{
                product_id:this.$route.query.product_id
              }
            });
          }
        });
      });
    },
    // 失去焦点验证手机号
    validationBlur(t){
      if(!phoneValidation(this.userInfo[t])){
        this.$toast('手机号不正确！');
      }
    },
    /*
     *@param:
     *@return:
     *@Description: 验证数据是否为空
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:09:34
     */
    validationHandle() {
      let u = this.userInfo;

      let b = true;
      for(let i=0;i<this.component.length;i++){
        let item = u[this.component[i].name];
        if(this.component[i].required  && !item){
            b= false;
            break;
        }
        if(item instanceof Array && item.length==0){
            b= false;
            break;
        }
      }
      this.bool = b;
    },
    /*
     *@param: val 当前点击的下拉窗
     *@return:
     *@Description: 点击选择框触发
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 11:46:29
     */
    selectHandle(val,arr) {
      this.options[val] = arr; 
      this.selectType = val;
      this.pickerShow = true;
    },
    /*
     *@Description: 下拉选择的值
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-07 18:51:09
     */
    puckerCfm(val) {
      this.userInfo[this.selectType] = val;
      this.validationHandle();
      this.pickerShow = false;
    },
    // 确认选择城市触发
    cityCfm(picker) {
      this.userInfo[this.selectType] = picker[0].name + " " + picker[1].name;
      this.validationHandle();
      this.citysShow = false;
    },
    /*
     *@Description: 初始化请求数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-11 18:08:59
     */
    pullData() {
      // loading
      //调用加载中
      this.$emit('loadingHandle',true,"加载中...");
      ceping_present().then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        document.title = data.title;
        this.dataObj = data;
        this.component = data.component;

        for(let i=0;i<data.component.length;i++){
            if(data.submit){
                if(data.submit[data.component[i].name]){
                  this.userInfo[data.component[i].name] = data.submit[this.component[i].name];
                }
                
            }
            
        }


        this.bodyShow = true;
        this.validationHandle();
        
        //关闭加载中
        this.$emit('loadingHandle',false);
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss">
.ms-information {
  padding: 30px;
  background-color: #f0f0f0;
  .ms-bg{
    background-color: #EB5032;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 290px;
    z-index: 1;
  }
  .ms-infor {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 50px 30px 85px;
    position: relative;
    z-index: 2;
    h3 {
      font-size: 34px;
      color: #333333;
      margin-bottom: 50px;
      font-weight: bold;
      letter-spacing: 1px;
      border-left: 8px solid #EB5032;
      padding-left: 14px;
      &:last-child{
        margin-bottom: 0px;
      }
    }
    .infor-group {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-bottom: 30px;
      h4 {
        font-size: 28px;
        color: #333333;
        font-weight: 400;
        line-height: 1;
        margin-bottom: 10px;
      }
      input[type="text"] {
        border: 2px solid #cccccc;
        border-radius: 8px;
        line-height: 70px;
        padding: 0 20px;
        font-size: 26px;
      }
      // select
      .select {
        position: relative;
        .input {
          color: #999999;
          display: block;
          border: 2px solid #cccccc;
          border-radius: 8px;
          line-height: 70px;
          padding: 0 20px;
          font-size: 26px;
        }
        .input.color3 {
          color: #333333;
        }
        .bottom {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 18px;
          img {
            width: 28px;
            height: 16px;
          }
        }
      }
      // radio
      .radio-group{
        display:flex;
        margin-top:30px;
        label{
          display:flex;
          font-size:28px;
          &:nth-child(2){
            margin-left:80px;
          }
          .radio{
            width:32px;
            height:32px;
            border-radius:50%;
            border:2px solid #ccc;
            margin-right:24px;
            align-items: center;
          }
          .radio.on{
            background-color:#EB5032;
            border:0;
          }
        }
      }
    }
    .infor-group.last{
        margin-bottom: 0px;
    }
  }
  //   提价按钮组
  .submit-group {
    margin: 70px auto 0px;
    font-size: 32px;
    display: flex;
    justify-content: center;
    .skip {
      display: block;
      width: 174px;
      text-align: center;
      line-height: 64px;
      color: #eb5032;
      border-radius: 32px;
      border: 2px solid #eb5032;
      margin-right: 80px;
    }
    .submitBtn {
      display: block;
      width: 578px;
      text-align: center;
      line-height: 80px;
      color: #ffffff;
      border-radius: 40px;
      background-color: #cccccc;
    }
    .submitBtn.on {
      background-color: #eb5032;
    }
  }
}
</style>